import ApiService from '../api.service';
import {retornoApi, retornoApiError} from '../../mixins/api';

const VTWhatsapp = {
    validar: async function (numero) {
        try {
            return retornoApi(await ApiService.post(ApiService.rotas("api.utils.validar-whatsapp"), {numero: numero}));
        } catch (error) {
            return retornoApiError(error);
        }
    },
};

export default VTWhatsapp;

export {VTWhatsapp};
